export const IMAGES = {
  heroHouse:
    "https://images.unsplash.com/photo-1759350841721-1de535a07675?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBkdXRjaCUyMGhvdXNlJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzg3OTM5MjkwfDA&ixlib=rb-4.1.0&q=85",
  wind:
    "https://images.unsplash.com/photo-1675116731363-c17d957f3444?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxzdXN0YWluYWJpbGl0eSUyMHdpbmQlMjB0dXJiaW5lJTIwbmF0dXJlfGVufDB8fHx8MTc4NzkzOTI5MHww&ixlib=rb-4.1.0&q=85",
  inspector:
    "https://images.unsplash.com/photo-1761558794306-466448dab4bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBpbnNwZWN0b3IlMjBjbGlwYm9hcmR8ZW58MHx8fHwxNzg3OTM5MjkwfDA&ixlib=rb-4.1.0&q=85",
};

export const PRICES = [
  { type: "Appartement", slug: "appartement", price: 139 },
  { type: "Tussenwoning", slug: "tussenwoning", price: 149 },
  { type: "Hoekwoning", slug: "hoekwoning", price: 159 },
  { type: "2-onder-1-kapwoning", slug: "2-onder-1-kapwoning", price: 169 },
  { type: "Vrijstaande woning", slug: "vrijstaande-woning", price: 199 },
];

export const PRICE_NOTE =
  "Introductietarieven inclusief btw. De uiteindelijke prijs kan afhankelijk zijn van onder andere woninggrootte, complexiteit en locatie. U ontvangt altijd vooraf een definitieve offerte.";

export const REGIO_PLACES = [
  "Rotterdam",
  "Schiedam",
  "Vlaardingen",
  "Capelle aan den IJssel",
  "Barendrecht",
  "Ridderkerk",
  "Spijkenisse",
  "Delft",
  "Dordrecht",
  "Gouda",
  "Zoetermeer",
  "Den Haag",
];

export const FAQ_ITEMS = [
  {
    q: "Hoe lang duurt een woningopname?",
    a: "Een EP-W woningopname duurt doorgaans 45 tot 60 minuten, afhankelijk van de grootte en complexiteit van de woning. De adviseur bekijkt onder andere de isolatie, kozijnen en beglazing, verwarming, warmwatervoorziening en ventilatie.",
  },
  {
    q: "Welke documenten moet ik klaarleggen?",
    a: "Niets is verplicht, maar het versnelt de opname als u het bouwjaar, eventuele bouwtekeningen en specificaties van de cv-ketel, isolatie of zonnepanelen bij de hand heeft. Ontbreekt iets? Geen probleem, de adviseur neemt de woning ter plaatse op.",
  },
  {
    q: "Wanneer ontvang ik mijn energielabel?",
    a: "Na de woningopname wordt uw energielabel verwerkt en geregistreerd in EP-online, de landelijke database van het RVO. U ontvangt van ons bericht zodra het label beschikbaar is, doorgaans binnen enkele werkdagen na de opname.",
  },
  {
    q: "In welke regio werkt Directelabels?",
    a: "Directelabels is actief in Rotterdam en omgeving, waaronder Schiedam, Vlaardingen, Capelle aan den IJssel, Barendrecht, Ridderkerk, Spijkenisse, Delft, Dordrecht, Gouda, Zoetermeer en Den Haag. Woont u elders in Zuid-Holland of net daarbuiten? Neem contact op, dan kijken we samen naar de mogelijkheden.",
  },
  {
    q: "Wat kost een energielabel?",
    a: "Onze introductietarieven beginnen bij €139 inclusief btw voor een appartement en lopen op tot €199 voor een vrijstaande woning. De uiteindelijke prijs kan afhankelijk zijn van woninggrootte, complexiteit en locatie. U ontvangt altijd vooraf een definitieve offerte.",
  },
  {
    q: "Is een energielabel verplicht bij verkoop of verhuur?",
    a: "Ja. Bij de verkoop of verhuur van een woning en bij de oplevering van nieuwbouw is een geldig energielabel verplicht. Zonder geldig label riskeert u een boete van de Inspectie Leefomgeving en Transport (ILT).",
  },
  {
    q: "Hoe lang is een energielabel geldig?",
    a: "Een geregistreerd energielabel is tien jaar geldig. Heeft u uw woning verduurzaamd, bijvoorbeeld met isolatie of zonnepanelen? Dan kan een heropname zinvol zijn om een beter label vast te leggen.",
  },
];
